module.exports = __webpack_public_path__ + "media/store/fonts/BeausiteClassic-Medium_web-a2fbf6553a77affbb9ab602aacf3254c.woff2";